import React from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'

import { Loader } from 'main/components/common'
import { AppContext, useWhitelabel } from 'main/framework'
import { IUser } from 'main/gql/user'
import useSSOContext from 'main/hooks/useSSOContext'
import { corpPath, guestHomePath, maybeUserHomePath, searchPath } from 'main/routes'
import WSA from 'sdk/sso'
import { PROD, STAGING } from 'sdk/sso/config/env'

const TIMEOUT = 2500

export default function HomeSSO(props: RouteComponentProps) {
  const { history } = props
  const [didTimeout, setDidTimeout] = React.useState(false)

  const isProd = WSA.env === PROD
  const isStaging = WSA.env === STAGING
  const { isLoading, isUserLoading, isReady, isAuthenticated } = WSA.Components.useWSAuth()
  const { user } = React.useContext(AppContext)
  const { navContext } = useSSOContext()
  const { isWhitelabeled } = useWhitelabel()
  const isUserLoadingFinished = (!isLoading && !isUserLoading && isReady) || didTimeout
  const hasUser = isUserLoadingFinished && isAuthenticated && !!user
  const isMaybeRedirect = isProd || isStaging
  const isOnboarding = navContext?.isOnboarding
  const shouldRedirect = isMaybeRedirect && isUserLoadingFinished && !hasUser && !isOnboarding

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasUser) {
        // wait a maximum amount of time to look for user
        setDidTimeout(true)
      }
    }, TIMEOUT)
    return () => {
      clearTimeout(timer)
    }
  }, [isReady, isUserLoading, isAuthenticated])

  // ->> maybeUserHomePath effect
  React.useEffect(() => {
    if (isUserLoadingFinished && hasUser) {
      history.replace(maybeUserHomePath(user as IUser))
    }
  }, [isUserLoadingFinished, hasUser])

  if (isUserLoadingFinished) {
    if (hasUser) {
      // maybeUserHomePath effect ->>
    } else {
      if (shouldRedirect) {
        if (isWhitelabeled) {
          // we don't want to redirect to corp on whitelabeled sites, since corp is not relevant to our whitelabel customers
          // using <Redirect /> will use the react router first, rending the old search page (lego/apps/lego/assets/js/main/Router.tsx)
          window.location.replace(searchPath())
        } else {
          return <Redirect to={corpPath()} />
        }
      } else {
        return <Redirect to={guestHomePath()} />
      }
    }
  }
  return <Loader />
}
